module.exports = __webpack_public_path__ + "img/shaixuan.bfd686f4.png";